export default __webpack_public_path__ + "static/media/RlSkill.fa1d74d3.PNG";